import { render, staticRenderFns } from "./WelcomeContactCard.vue?vue&type=template&id=293fe583&"
import script from "./WelcomeContactCard.vue?vue&type=script&lang=js&"
export * from "./WelcomeContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports